import React from 'react';
import { useLocalizedData } from '../hooks/useTranslatedContent';

function MissionAbout({ aboutData }) {
    const {
        getLocalized,
        getLocalizedArray
    } = useLocalizedData(aboutData);

    if (!aboutData) return null;

    const titleMission = getLocalized('titleMission');
    const subTitleMission = getLocalized('subTitleMission');
    const descriptionMission = getLocalized('descriptionMission');
    const missions = getLocalizedArray('missions') || [];

    return (
        <section className="py-28 px-7 md:px-8 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8 items-start">
                <div>
                    {subTitleMission && (
                        <h6 className="text-sm text-gray-500 uppercase mb-2">
                            {subTitleMission || ""}
                        </h6>
                    )}

                    <h2 className="text-3xl font-bold mb-4 text-gray-800">
                        {titleMission || "Our Mission & Vision"}
                    </h2>

                    <div className="w-20 h-1 bg-black-600 mb-4" />

                    {descriptionMission && (
                        <p
                            className="text-gray-600 text-base leading-relaxed"
                            dangerouslySetInnerHTML={{
                                __html: descriptionMission ||
                                    ""
                            }}
                        />
                    )}
                </div>

                <div className="grid sm:grid-cols-2 gap-7">
                    {missions.map((item, index) => {
                        if (!item || (!item.title && !item.description)) return null;

                        return (
                            <div
                                key={item.id || `mission-${index}`}
                                className="bg-gray-100  rounded-2xl shadow-md text-center hover:shadow-lg transition-shadow"
                            >
                                {item.img && (
                                    <img
                                        src={item.img}
                                        alt={item.title || 'Mission icon'}
                                        className="mx-auto mb-4 w-24 h-24 object-contain"
                                    />
                                )}

                                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                    {item.title || ""}
                                </h3>

                                {item.description && (
                                    <p
                                        className="text-gray-600 text-sm"
                                        dangerouslySetInnerHTML={{
                                            __html: item.description ||
                                                ""
                                        }}
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default MissionAbout;